import { Badge, Button, MenuItem, MenuList } from '@mui/material'
import React from 'react'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { GridMenu } from '@mui/x-data-grid';

export default function CustomViewMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleViewUpdate = (newView) => {
        props.setShowMenuSelected(newView);
        setAnchorEl(null);
    };

    const ViewOptions = [
        {
            label: 'All',
            value: 'All'
        },
        {
            label: 'Outstanding',
            value: 'Outstanding'
        },
        {
            label: 'Responded',
            value: 'Responded'
        },
        {
            label: 'Closed',
            value: 'Closed'
        },
        {
            label: 'Accepted',
            value: 'Accepted'
        },
        {
            label: 'Rejected',
            value: 'Rejected'
        },
    ];

    const renderViewOptions = ViewOptions.map((option, index) => (
        <MenuItem
            key={index}
            selected={props.showMenuSelected === option.label}
            onClick={() => handleViewUpdate(option.value)}
        >
            {option.label}
        </MenuItem>
    ));

    return (
        <>
            <Button
                size="small"
                startIcon={
                    <Badge badgeContent={props.showMenuSelected !== 'All' ? 1 : 0} color="primary">
                        <RemoveRedEyeOutlinedIcon />
                    </Badge>
                }
                onClick={handleClick}
                aria-label="view"
                aria-expanded={anchorEl ? 'true' : undefined}
                aria-haspopup="menu"
            >
                Show
            </Button>

            <GridMenu
                open={Boolean(anchorEl)}
                target={anchorEl}
                onClickAway={handleClose}
                position="bottom-start"
            >
                <MenuList
                    id="custom-view"
                    className="MuiDataGrid-gridMenuList"
                    autoFocusItem={Boolean(anchorEl)}
                    onKeyDown={handleClose}
                >
                    {renderViewOptions}
                </MenuList>
            </GridMenu>
        </>
    )
}

